import { createFeatureSelector } from '@ngrx/store';
import { FeedbackState } from './feedback.reducer';

export const selectFeedbackState = createFeatureSelector<FeedbackState>('feedback');
